/**
 * Relative timestamp cell - "3h ago" with the absolute time on hover,
 * rendered as a semantic <time> element, falling back to "Never".
 * One home for the pattern used by the admin user lists, the User
 * Activity report and the FP engagement card.
 */

import React from 'react'
import { Typography, TypographyProps } from '@mui/material'
import { formatRelativeTimestamp } from '../../utils/dateFormatters'

interface RelativeTimeProps {
  value?: string | Date | null
  variant?: TypographyProps['variant']
  neverLabel?: string
}

export const RelativeTime: React.FC<RelativeTimeProps> = ({
  value,
  variant = 'body2',
  neverLabel = 'Never',
}) => {
  if (!value) {
    return (
      <Typography variant={variant} color="text.secondary">
        {neverLabel}
      </Typography>
    )
  }
  const { label, title, dateTime } = formatRelativeTimestamp(value)
  return (
    <Typography
      component="time"
      dateTime={dateTime}
      title={title}
      variant={variant}
      sx={{ cursor: 'help' }}
    >
      {label}
    </Typography>
  )
}

export default RelativeTime
